import React from 'react'

const Categories = ({ categories, filterItems }) => {
  return (
    <div className="container btn-container">
      <div>
        <div>

      {categories.map((category, index) => {
        return (
          <button
            type="button"
            className="filter-btn"
            key={index}
            onClick={() => filterItems(category)}
          >
            {category}
          </button>
        )
      })}
        </div>
      </div>
    </div>
  )
}

export default Categories
